import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LifeBuoy, AlertTriangle, ClipboardList, X } from 'lucide-react';

// "Get Support" quick-action tile — tapping it opens a small sheet offering the
// two things a customer might mean by "support": a Complaint (fault/issue ticket)
// or a Request (plan change, disconnection, etc.), instead of guessing which one.
export default function SupportQuickAction() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const choose = (to) => { setOpen(false); navigate(to); };

  return (
    <>
      <button onClick={() => setOpen(true)} style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '12px 6px',
        border: '1px solid var(--border)', borderRadius: 12, background: 'none', cursor: 'pointer', width: '100%',
      }}>
        <div style={{
          width: 34, height: 34, borderRadius: 10, background: '#dc262614', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <LifeBuoy size={16} color="#dc2626" />
        </div>
        <span style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--text)', textAlign: 'center' }}>Get Support</span>
      </button>

      {open && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 80, display: 'flex', alignItems: 'flex-end' }}>
          <div onClick={() => setOpen(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.4)' }} />
          <div style={{
            position: 'relative', width: '100%', background: 'var(--bg-card, #fff)',
            borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: '18px 20px calc(20px + env(safe-area-inset-bottom, 0px))',
            boxShadow: '0 -4px 20px rgba(0,0,0,.15)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontWeight: 800, fontSize: '1rem' }}>How can we help?</span>
              <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}>
                <X size={20} />
              </button>
            </div>

            <button onClick={() => choose('/portal/complaints?new=1')} style={sheetBtn}>
              <div style={{ ...iconWrap, background: '#fee2e2' }}>
                <AlertTriangle size={18} color="#dc2626" />
              </div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontWeight: 700, fontSize: '.9rem' }}>Raise a Complaint</div>
                <div style={{ fontSize: '.78rem', color: 'var(--text-muted)' }}>Signal issue, no internet, billing problem, etc.</div>
              </div>
            </button>

            <button onClick={() => choose('/portal/requests?new=1')} style={{ ...sheetBtn, marginTop: 10 }}>
              <div style={{ ...iconWrap, background: '#fef3c7' }}>
                <ClipboardList size={18} color="#d97706" />
              </div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontWeight: 700, fontSize: '.9rem' }}>Send a Request</div>
                <div style={{ fontSize: '.78rem', color: 'var(--text-muted)' }}>Plan change, disconnection, referrals, etc.</div>
              </div>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const sheetBtn = {
  width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '12px 10px',
  border: '1px solid var(--border)', borderRadius: 12, background: 'none', cursor: 'pointer',
};
const iconWrap = {
  width: 38, height: 38, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
};
